import { createSlice } from "@reduxjs/toolkit/"

let initialState = {
    tutorielsList : [],
    selectedChoice:{},
}
const tutorielSlice = createSlice({
    name:'tutoriels',
    initialState,
    reducers:{
        setTutorielsList:(state,{payload})=>{
            state.tutorielsList = payload
        },
        setSelectedTutoriel:(state,{payload})=>{
            state.selectedTutoriel = payload
        },
    }
})

export const { setTutorielsList,setSelectedTutoriel } = tutorielSlice.actions
export default tutorielSlice.reducer